import { EnfinitySecondaryBtn } from "@/components/design-system/enfinity/EnfinityButton";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ArrowLeft, ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function MediaCompanies() {
  const { ref, isVisible } = useScrollReveal();
  const categories = [
    {
      title: "Talent Agencies",
      description: "Protect your entire roster",
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/talent.png",
    },
    {
      title: "Sports Networks",
      description: "Secure game footage",
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/ball.png",
    },
    {
      title: "TV, Film & Animation",
      description: "Protect productions",
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/film.png",
    },
    {
      title: "Media Companies",
      description: "Safeguard your catalog",
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/company.png",
    },
    {
      title: "Multi-Channel Networks",
      description: "Scale protection across channels",
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/network.png",
    },
  ];

  const features = [
    {
      title: "Protect entire rosters instantly",
      description: "One dashboard for hundreds or thousands of creators",
    },
    {
      title: "White-label solution available",
      description: "Brand it as your own protection service",
    },
    {
      title: "API & bulk management",
      description: "Integrate with your systems, protect at scale",
    },
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 xxs:py-8 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left Section - Card */}
          <div className="bg-white rounded-[20px] shadow-[0px_0px_6px_0px_rgba(16,185,129,0.25)] w-full lg:w-[412px] h-auto min-h-[600px] p-[21px] flex flex-col flex-shrink-0 order-2 lg:order-1">
            {/* Header */}
            <div className="relative mb-[31.5px]">
              <ArrowLeft className="absolute left-0 top-0 w-6 h-6 text-black" />
              <p className="text-base xxs:text-base xs:text-base sm:text-lg md:text-lg lg:text-[20px] font-medium text-black text-center enfinity-header-font">
                For media companies
              </p>
            </div>

            {/* Categories List */}
            <div className="flex flex-col gap-[15px] mb-6 w-full lg:w-[370px]">
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="bg-[#f7f8fa] rounded-[10px] px-4 xxs:px-4 xs:px-5 sm:px-5 md:px-6 lg:px-[22px] py-3 xxs:py-3 xs:py-3 sm:py-4 md:py-4 lg:py-[19px] flex items-center gap-3 xxs:gap-3 xs:gap-4 sm:gap-4 md:gap-5 lg:gap-[23px] h-auto xxs:h-auto xs:h-auto sm:h-auto md:h-auto lg:h-[82.5px] min-h-[70px] xxs:min-h-[70px] xs:min-h-[70px] sm:min-h-[75px] md:min-h-[80px]"
                >
                  <div className="flex gap-[10px] items-center flex-1">
                    {/* Purple Circle */}
                    <div className="bg-[#8b5cf6] rounded-full w-[40px] h-[40px] xxs:w-[40px] xxs:h-[40px] xs:w-[42px] xs:h-[42px] sm:w-[44px] sm:h-[44px] md:w-[45px] md:h-[45px] lg:w-[47px] lg:h-[47px] flex-shrink-0 flex items-center justify-center overflow-hidden">
                      <img
                        src={category.icon}
                        alt={category.title}
                        className="w-full h-full object-contain p-2"
                      />
                    </div>

                    {/* Text */}
                    <div className="flex flex-col gap-[5px] justify-center">
                      <p className="text-sm xxs:text-xs xs:text-sm sm:text-sm md:text-base lg:text-[18px] font-medium text-black enfinity-header-font">
                        {category.title}
                      </p>
                      <p className="text-[10px] xxs:text-[10px] xs:text-[10px] sm:text-xs md:text-xs lg:text-[14px] font-normal text-[rgba(0,0,0,0.5)] enfinity-subtext-font">
                        {category.description}
                      </p>
                    </div>
                  </div>

                  {/* Check Icon */}
                  <div className="bg-[#8b5cf6] rounded-full w-6 h-6 xxs:w-6 xxs:h-6 xs:w-7 xs:h-7 sm:w-7 sm:h-7 md:w-7 md:h-7 lg:w-8 lg:h-8 flex items-center justify-center flex-shrink-0">
                    <Check
                      className="w-4 h-4 xxs:w-4 xxs:h-4 xs:w-4 xs:h-4 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-5 lg:h-5 text-white"
                      strokeWidth={2}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Enterprise Button */}
            <Link to="/contact-us">
              <EnfinitySecondaryBtn className="w-full font-medium py-6 rounded-[100px] px-[40px] justify-center gap-[10px] bg-[#8b5cf6] hover:bg-[#7336ff] text-white border-[#8b5cf6] hover:border-[#73336ff]">
                <span className="text-sm xxs:text-sm xs:text-sm sm:text-sm md:text-base lg:text-[15px] font-medium enfinity-subtext-font">
                  Contact Enterprise
                </span>
                <ArrowUpRight className="w-5 h-5" />
              </EnfinitySecondaryBtn>
            </Link>
          </div>

          {/* Right Section */}
          <div className="flex-1 flex flex-col gap-[27px] max-w-[728px] order-1 lg:order-2">
            {/* Numbered Badge */}
            <div className="bg-gradient-to-b from-[#8b5cf6] to-[#7336ff] rounded-[100px] w-[77px] h-[50px] flex items-center justify-center">
              <p className="text-[32px] font-semibold text-white">02</p>
            </div>

            {/* Main Heading */}
            <h1
              className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal enfinity-header-font"
              style={{ lineHeight: "1.2" }}
            >
              <span>Built for </span>
              <span className="text-[#8b5cf6] enfinity-header-font">
                media companies
              </span>
            </h1>

            {/* Description */}
            <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black leading-[34px] enfinity-subtext-font">
              Whether you license UGC, manage creator rosters, or protect
              premium content libraries, EnfiniShield provides an all-in-one
              protection platform system for modern media organizations.
            </p>

            {/* Features List */}
            <div className="flex flex-col gap-[30px] max-w-[680px]">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-[15px] items-start">
                  {/* Check Icon */}
                  <div className="bg-[#8b5cf6] rounded-[10px] w-6 h-6 xxs:w-6 xxs:h-6 xs:w-7 xs:h-7 sm:w-7 sm:h-7 md:w-7 md:h-7 lg:w-8 lg:h-8 flex items-center justify-center flex-shrink-0">
                    <Check
                      className="w-4 h-4 xxs:w-4 xxs:h-4 xs:w-4 xs:h-4 sm:w-4 sm:h-4 md:w-5 md:h-5 lg:w-5 lg:h-5 text-white"
                      strokeWidth={2}
                    />
                  </div>

                  {/* Feature Content */}
                  <div className="flex flex-col gap-[10px]">
                    <p className="text-lg xxs:text-base xs:text-lg sm:text-lg md:text-xl lg:text-[24px] font-medium text-black leading-[28px] xxs:leading-[24px] xs:leading-[26px] sm:leading-[28px] md:leading-[30px] lg:leading-[35px] enfinity-header-font">
                      {feature.title}
                    </p>
                    <p className="text-base xxs:text-[1rem] lg:text-[18px] font-normal text-black leading-normal enfinity-subtext-font">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
